import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import EvTaxCreditContainer from '@/ev-tax-credit/EvTaxCreditContainer';
import { evProject, evTrack } from '~/constants/eventable';
import EvProviders from '~/context/ev-tax-credit/EvProviders';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

export default function EvTaxCredit() {
  return (
    <div>
      <NextSeo
        title="Used Ev Tax Credit Cars for Sale Online | Carvana"
        description="Used Ev Tax Credit Cars for Sale Online | Carvana"
      />
      <ErrorBoundary>
        <EvProviders eventableProject={evProject} eventableTrack={evTrack}>
          <EvTaxCreditContainer />
        </EvProviders>
      </ErrorBoundary>
    </div>
  );
}

export const getStaticProps: GetStaticProps<{}> = () => {
  return {
    props: {}
  };
};
